import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DisplayLabelPipe, OrderExecTypePipe } from '@zero/shared/ui-pipes';
import { OrderData } from '@zero/shared/util-models';

@Component({
  selector: 'order-item-exec-type',
  templateUrl: './order-item-exec-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe, DisplayLabelPipe, OrderExecTypePipe, DecimalPipe],
})
export class OrderItemExecTypeComponent {
  @Input() public order!: OrderData;
}
